import { DOCUMENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/documents_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['location_documents']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
